import { AnalyticsEventAttribute } from '../../constants/AnalyticsEventAttribute';
import { cleanPhoneNumber } from '../../utils/phoneUtils';
import { DEFAULT_PHONE_NUMBER } from '../../constants/phone';
import { FormattedMessage } from 'react-intl';
import { RootState, useAppSelector } from '../../redux/store';
import {
  BranchContact,
  BranchContactPhoneNumber,
  BranchContactBox,
  TextBold,
} from './BranchContactStyle';

export default function BranchContactPhone() {
  const branch = useAppSelector((state: RootState) => state.location.branch);

  const handlePhoneClick = () => {
    const cleanedPhoneNumber = cleanPhoneNumber(
      branch?.location?.location_phone ?? DEFAULT_PHONE_NUMBER,
    );
    // Set the location to the cleaned phone number
    window.location.href = `tel:${cleanedPhoneNumber}`;
  };

  return (
    <BranchContactBox>
      <BranchContact>
        <TextBold>
          <FormattedMessage id='branch.haveQuestions' />
        </TextBold>
        <FormattedMessage id='branch.phoneText' />
        <BranchContactPhoneNumber
          data-event-tracking={AnalyticsEventAttribute.BranchPhone}
          onClick={handlePhoneClick}
        >
          <TextBold>
            {branch?.location?.location_phone
              ? branch.location.location_phone
              : DEFAULT_PHONE_NUMBER}
          </TextBold>
        </BranchContactPhoneNumber>
      </BranchContact>
    </BranchContactBox>
  );
}
